import { isTourDocumentCustomer } from './is-tour-document-customer'
import type { TourDocumentView } from './types'

export const canPayTourDocument = (
  document: Pick<TourDocumentView, 'canPay' | 'status' | 'remainingAmount'>,
): boolean =>
  isTourDocumentCustomer(document) &&
  [
    'DOCUMENT_TO_TOUR',
    'TOUR_AWAITING_BOOKING',
    'ADDITIONAL_TO_PAID',
    'PAY_LAST_DAY',
  ].includes(document.status) &&
  document.remainingAmount !== null &&
  document.remainingAmount > 0
